import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import store from './store';
import {firebaseStartListeners} from './firebase';
firebaseStartListeners(store);

import {get} from './xhr';
import {Router, IndexRoute, Route, browserHistory} from 'react-router';
import App from './components/App';
import Viewer from './components/Viewer';
import Admin from './components/Admin';

require('../scss/app.scss');

ReactDOM.render(
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path="/" component={App}>
                <IndexRoute                   component={Viewer} depth={0} mode="home" />
                <Route path="favourites"      component={Viewer} depth={1} mode="favourites" />
                <Route path="venue"           component={Viewer} depth={1} mode="venue" />
                <Route path="venue/:id"       component={Viewer} depth={2} mode="venue" />
                <Route path="band"            component={Viewer} depth={1} mode="band" />
                <Route path="band/:id"        component={Viewer} depth={2} mode="band" />
                <Route path="accompanist"     component={Viewer} depth={1} mode="accompanist" />
                <Route path="accompanist/:id" component={Viewer} depth={2} mode="accompanist" />
                <Route path="admin/">
                    <IndexRoute component={Admin} />
                </Route>
            </Route>
        </Router>
    </Provider>,
    document.getElementById('app')
);


// TODO - REMOVE HACKERY
import {db} from './firebase';
window.store = store;
window.db = db;



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/